import Hero from "./components/Hero";
import AreaBelt from "./components/AreaBelt";
import ServicesPreview from "./components/ServicesPreview";
import TrustStats from "./components/TrustStats";
import HowItWorks from "./components/HowItWorks";
import PricingSnapshot from "./components/PricingSnapshot";
import Testimonial from "./components/Testimonial";
import AreaTeaser from "./components/AreaTeaser";
import FAQ from "./components/FAQ";
import CTASection from "@/components/feature/CTASection";

export default function Home() {
  return (
    <>
      <Hero />
      <AreaBelt />
      <ServicesPreview />
      <TrustStats />
      <HowItWorks />
      <PricingSnapshot />
      <Testimonial />
      <AreaTeaser />
      <FAQ />
      <CTASection
        eyebrow="Ready when you are"
        title={
          <>
            Local electrician,<br />
            <em className="not-italic text-accent-600">just around the corner.</em>
          </>
        }
        subtitle="Book a visit in under a minute — same-week slots most weeks."
      />
    </>
  );
}